import { utils, writeFileXLSX } from "xlsx";

import MaskAndValid from "utils/maskAndValid";

function formatDateTime(value) {
  if (!value) return "";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(value);
  }
}

function buildItensRows(detalhes) {
  const rows = [];

  (detalhes || []).forEach((det) => {
    const idPedido =
      det.IdVitrineVirtualB2bPedido ?? det.idVitrineVirtualB2bPedido ?? "";
    const cnpj = det.CnpjLoja ?? det.cnpjLoja ?? "";
    const header = {
      "ID Pré-pedido": idPedido,
      "Cód. Vitrine": det.IdVitrineVirtualB2b ?? det.idVitrineVirtualB2b ?? "",
      Vitrine: det.NomeVitrine ?? det.nomeVitrine ?? "",
      CNPJ: cnpj ? MaskAndValid.maskCNPJ(String(cnpj)) : "",
      Consumidor: det.RazaoSocialLoja ?? det.razaoSocialLoja ?? "",
      "Data pré-pedido": formatDateTime(det.DataPrePedido ?? det.dataPrePedido),
      "Status pedido": det.Status ?? det.status ?? "",
      "Valor total pedido (R$)": Number(det.ValorTotal ?? det.valorTotal ?? 0),
    };

    const itens = det.Itens ?? det.itens ?? [];
    if (itens.length === 0) {
      rows.push({
        ...header,
        "ID Produto": "",
        "Nome produto": "",
        Linha: "",
        "Condição pagamento": "",
        Quantidade: "",
        "Valor unitário (R$)": "",
        "Encargo (%)": "",
        "Desconto (%)": "",
        "Valor total linha (R$)": "",
      });
      return;
    }

    itens.forEach((item) => {
      rows.push({
        ...header,
        "ID Produto": item.IdProduto ?? item.idProduto ?? "",
        "Nome produto": item.NomeProduto ?? item.nomeProduto ?? "",
        Linha: item.Linha ?? item.linha ?? "",
        "Condição pagamento":
          item.CondicaoPagamento ?? item.condicaoPagamento ?? "",
        Quantidade: Number(item.Quantidade ?? item.quantidade ?? 0),
        "Valor unitário (R$)": Number(
          item.ValorUnitario ?? item.valorUnitario ?? 0,
        ),
        // Já embutido no valor unitário (ver FinalizarPedido) — mostrado aqui só pra
        // reconciliação/auditoria (quanto do preço é encargo financeiro da condição).
        "Encargo (%)": Number(
          item.PercentualEncargo ?? item.percentualEncargo ?? 0,
        ),
        "Desconto (%)": Number(
          item.DescontoPercentual ?? item.descontoPercentual ?? 0,
        ),
        "Valor total linha (R$)": Number(
          item.ValorTotalLinha ?? item.valorTotalLinha ?? 0,
        ),
      });
    });
  });

  return rows;
}

function buildFileName(idPedido) {
  const now = new Date();
  const stamp = now.toISOString().slice(0, 10).replace(/-/g, "");
  const time = `${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}`;
  if (idPedido != null && idPedido !== "") {
    return `PrePedido_VitrineB2B_${idPedido}_${stamp}_${time}.xlsx`;
  }
  return `PrePedidos_VitrineB2B_${stamp}_${time}.xlsx`;
}

export default function exportPrePedidosToXlsx({ detalhes, idPedido }) {
  const wb = utils.book_new();

  const itensRows = buildItensRows(detalhes);
  if (itensRows.length > 0) {
    const wsItens = utils.json_to_sheet(itensRows);
    utils.book_append_sheet(wb, wsItens, "Itens");
  }

  if (!wb.SheetNames.length) {
    const wsEmpty = utils.json_to_sheet([
      { Mensagem: "Nenhum pré-pedido encontrado para os filtros aplicados." },
    ]);
    utils.book_append_sheet(wb, wsEmpty, "Itens");
  }

  writeFileXLSX(wb, buildFileName(idPedido));
}
